import React from "react";
import { useNavContext } from "../../context-api/nav-context";

const HomeReviews = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="home-intro" onMouseOver={closeNavbarMenu}>
      <div className="section-wrapper home-reviews-margin">
        <div className="content-container">
          <h2 className="title">
            Our Customers Love Our Work. Read What They Have To Say
          </h2>
          <p className="subtitle"></p>
        </div>
      </div>
      <div className="reviews-image">
        <img
          src="https://res.cloudinary.com/duwmjod0j/image/upload/q_100/v1642187765/AquaHeat/Home%20Reviews/reviews_oyltwu.webp"
          alt="reviews"
        />
      </div>
    </section>
  );
};

export default HomeReviews;
